import {Injectable} from "@angular/core";

@Injectable()
export class DonorNamesCacheService {

  contextApi = '/api';
  constructor() {}

  private cache: string[] = [];

  public getCache(): string[] {
    return this.cache;
  }
}
